import {
    ActionCreatorProps,
    createAction,
    props
} from '@ngrx/store';
import { IDatiqAnalyticsEvent } from '@dat/datiq-core/models';

const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq File Download] ${name}`;
};
const defaultProp: ActionCreatorProps<IDatiqAnalyticsEvent> =
    props<IDatiqAnalyticsEvent>();

export const createNewDownloadName: string = createActionName(
    `create new file download`
);
export const createNewDownload = createAction(
    createNewDownloadName,
    defaultProp
);
